import { render, staticRenderFns } from "./PlayfieldSpecifications.vue?vue&type=template&id=6a1d185c&scoped=true&"
import script from "./PlayfieldSpecifications.vue?vue&type=script&lang=js&"
export * from "./PlayfieldSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./PlayfieldSpecifications.vue?vue&type=style&index=0&id=6a1d185c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d185c",
  null
  
)

export default component.exports